var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccommodationLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.3,
    transform: "translate(1 1)",
    stroke: "currentColor",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.375 15.193v2.932c0 .69.56 1.25 1.25 1.25h5c.69 0 1.25-.56 1.25-1.25v-2.932M19.375 14.568l-5.417-4.872a1.25 1.25 0 00-1.671 0L6.87 14.568M18.125 13.443V10"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.875,
    cy: 6.875,
    r: 3.125
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.875 19.375a.624.624 0 01-.52-.28C4.852 16.833.624 9.715.624 6.875a6.25 6.25 0 1112.5 0"
  }))));
}
export default SvgAccommodationLocation;